import React, { PureComponent } from 'react'
import * as R from 'ramda'

import SearchInput from '../components/SearchInput'
import DataTable from '../components/DataTable'

import './loginChoose.scss'
import Panel from '../UniformComponents/Panel'

class LoginChoose extends PureComponent {
    constructor(props) {
        super(props)
        const { store } = this.props

        this.columns = [
            {
                key: 'clientColumn',
                name: 'Client Name',
            },
            {
                key: 'name',
                name: 'User',
            },
            {
                key: 'role',
                name: 'Role',
                dataTransform: (role) => (
                    role === 'MASTER'
                        ? <span style={{ fontWeight: 700 }}>{role} USER</span>
                        : `${role} USER`
                ),
            },
        ]

        this.state = {
            filteredList: store.userAccounts,
        }
    }

    selectNew = async (e, uuid) => {
        const { store } = this.props
        const { csrf, userData } = store

        const userId = R.path(['userId'], userData)

        // location.href = `/login/choose?uuid=${uuid}&qUsers=-1&pagePath=`
        const query = new URLSearchParams(location.search)
        let requestUrl = '/api/login/choose'

        if (query.has('pagePath')) {
            requestUrl += `?pagePath=${query.get('pagePath')}`
        }

        const request = await fetch(requestUrl, {
            method: 'post',
            withCredentials: true,
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json; charset=UTF-8',
            }),
            body: JSON.stringify({
                userId,
                uuid,
                csrf,
            }),
        })

        const response = await request.json()

        location.href = response.redirect
    }

    selectOld = (e, uuid) => {
        location.href = `/login/choose?uuid=${uuid}&qUsers=-1&pagePath=`
    }

    select = (e, uuid) => {
        if (process.env.USE_NEW_LOGIN) {
            this.selectNew(e, uuid)
        } else {
            this.selectOld(e, uuid)
        }
    }

    search = () => {
        const { store } = this.props
        const regex = new RegExp(this.searchModule.searchStr.replace('[', '\\[').replace(']', '\\]'), 'gi')
        const filteredList = store.userAccounts.filter((account) => (
            account.clientColumn.match(regex)
            || account.name.match(regex)
            || account.role.match(regex)
        ))

        this.setState({
            filteredList,
        })
    }

    render() {
        const { filteredList } = this.state

        return (
            <div id="LoginChoose">
                <Panel cssClass="search-panel">
                    <SearchInput
                        ref={(s) => { this.searchModule = s }}
                        onChange={this.search}
                        autoFocus
                    />
                </Panel>
                <Panel cssClass="table-panel">
                    <DataTable
                        store={this.state}
                        dataSet={filteredList}
                        rowClick={this.select}
                        // inMemory
                        rowId="uuid"
                        columns={this.columns}
                        rowStyler={(row, index) => (index % 2 === 0 ? 'even' : 'odd')}
                    />
                </Panel>
            </div>
        )
    }
}

export default LoginChoose
